// let bunningsProducts = [
// 	{
// 		variantId: "44779468914867",
// 		title: "Easy Fit Pet Gate | 0.82m W x 0.76m H / White",
// 		bunningsUrl: "https://www.bunnings.com.au/perma-child-safety-easy-fit-pet-gate_p0879355"
// 	}, 
// 	{
// 		variantId: "42819927998643",
// 		title: "Baby Gate Extensions / 10cm / White",
// 		bunningsUrl: "https://www.bunnings.com.au/perma-child-safety-10cm-white-gate-extension_p0095267"
// 	}, 
// 	{
// 		variantId: "42591176360115",
// 		title: "Ultimate 3-in-1 Playpen Barrier / White",
// 		bunningsUrl: "https://www.bunnings.com.au/perma-child-safety-white-ultimate-3-in-1-playpen-barrier_p0417784"
// 	}, 
// 	{
// 		variantId: "42591176392883",
// 		title: "Ultimate 3-in-1 Playpen Barrier / Black",
// 		bunningsUrl: "https://www.bunnings.com.au/perma-child-safety-black-ultimate-3-in-1-playpen_p0658383"
// 	}, 
// 	{
// 		variantId: "44239405154483",
// 		title: "Easy Fit Baby Gate | 0.82m W x 0.76m H / White",
// 		bunningsUrl: "https://www.bunnings.com.au/perma-child-safety-easy-fit-baby-gate_p0095272"
// 	}
// ];



const shadowQuiz = document.getElementById('shadow-quiz');

function observeCartChanges(callback) {
    const cartEndpoints = [theme.routes.cart_add_url, theme.routes.cart_update_url, theme.routes.cart_change_url, theme.routes.cart_clear_url];
    new PerformanceObserver(list => {
        list.getEntries().forEach(entry => {
            (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest") && cartEndpoints.some(endpoint => entry.name.includes(endpoint)) && fetch("/cart.js").then(response => response.json()).then(cart => callback(cart))
        })
    }).observe({
        entryTypes: ["resource"]
    })
}
observeCartChanges(cart => {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: !0
    }))
});




function checkQuiz(delay = 1300) {
	return new Promise((resolve, reject) => {
		setTimeout(() => {
			const shadowHost = document.querySelector("#shadow-quiz");
			if (!shadowHost) {
				reject(new Error("Shadow host #shadow-quiz not found"));
				return
			}
			const shadowRoot = shadowHost.shadowRoot;
			if (!shadowRoot) {
				reject(new Error("Shadow root is not accessible"));
				return
			}
			resolve(shadowRoot)
		}, delay)
	})
}




function getSlotItems(timeout = 5000) {
	return new Promise((resolve, reject) => {
		const interval = 300; // ms
		const start = Date.now();
		const timer = setInterval(function() {
			let slotItems = window.Quiz.slotItems;
			if (slotItems) {
				clearInterval(timer);
				console.log("Slot items found...");
				resolve(slotItems);
			} else if (Date.now() - start > timeout) {
				clearInterval(timer);
				reject(new Error('Timed out.. Quiz slot items not found...'));
			}
		}, interval);
	})
}




// function checkProductResultCards(delay = 1500) {	
// 	return new Promise((resolve, reject) => {
// 		setTimeout(() => {
// 			const shadowHost = document.querySelector("#shadow-quiz");
// 			const elements = shadowHost.shadowRoot.querySelectorAll(".results-slot");
// 			const quiz = window.Quiz;
			
// 			if (elements.length > 0 && Array.from(elements).forEach(slot => {
// 					if(!slot.querySelector(".slot-variant__title")) return;
// 					let title = slot.querySelector(".slot-variant__title").textContent.trim(),
// 					matchedProduct = bunningsProducts.find(bunningsProduct => bunningsProduct.title == title);
// 					if (matchedProduct) {
// 						let atcButton = slot.querySelector(".slot-product__button");
// 						atcButton.style.display = "none";
									
// 						let buttonParent = atcButton.parentElement;
// 						if (!buttonParent.querySelector(".quiz-bunnings-button")) {
// 							let bunningsButton = document.createElement("a");
// 							bunningsButton.className = "quiz-bunnings-button",
// 							bunningsButton.href = matchedProduct.bunningsUrl,
// 							bunningsButton.innerHTML = `<img class="quiz-button-bunnings-image" src="${window.theme.bunnings.bunningsImageBackground}"/>`,
// 							buttonParent.appendChild(bunningsButton)
// 						}
// 						resolve(matchedProduct)
// 					}
// 				}), elements.length === 0) {
// 				reject(new Error("No Product Cards found or not in results page."));
// 				return
// 			}
// 		}, delay)
// 	})
// }



async function fetchData() {
	try {
		let productData = await fetch(`${theme.routes.root_url}products.json`)
		.then((response) => response.json())
		.then((response) => {
			if (response.status) {
				if(response.status === 422) {
					return; 
				}
			}
			return response;
		});	
	}
	catch {
		console.error("Fetched data is not an array");
	}
}




async function addVariantsGIDOnLoad(shadowRoot) {
	if(!shadowRoot) return;
	let rawItems = await getSlotItems();
	if(rawItems) {
		const slotItems = Object.values(rawItems);
		let buttons = shadowRoot.querySelectorAll('.slot-product__button');
		let gids = [];	

		if(buttons) {
			buttons.forEach(function(button, index) {
				button.dataset.gid = slotItems[index].id;
				let gid = slotItems[index].id;
				let gidSplit = gid.split('/');
				let variantID = Number(gidSplit.at(-1));
				gids.push({index: index, type: "variant", id: variantID, gid: slotItems[index].id});
			});
		}		
		
		let selects = shadowRoot.querySelectorAll('select.select-variants');
		if(selects) {
			selects.forEach( select => {
				options = select.querySelectorAll('option');
				options.forEach(option => {
					gidSplit = option.value.split('/');
					let variantID = Number(gidSplit.at(-1));
					gids.push({type: "product", id: variantID, gid: option.value});
				});
			});
		}
		
		if(gids.length > 0) {
			checkSoldoutByVariantGIDs(shadowRoot, gids);
		}
	}
}




function getAllUnavailableVariants(products) {
	const productMapVariants = products.map(product => product.variants);
	let unavailables = productMapVariants.filter(variant => variant.available == false);
	let variantList = [];

	products.forEach(product => {
		let variants = product.variants;
		if(!variants.length > 0) return;
		variants.forEach(variant => {
			if(!variant.available) {
				variantList.push(variant);
			}
		})		
	});

	if(!variantList) return;
	return variantList;
}



function checkSoldoutByVariantGIDs(shadowRoot, gids) {
	try {
		fetch(`${theme.routes.root_url}products.json?limit=250`)
		.then( (response) => response.json())
		.then((response) => {
			if (response.status) {
				if(response.status === 422) {
					return; 
				}
			}
			const products = response.products;
			const unavailables = getAllUnavailableVariants(products);
			console.log("VARIANTS", unavailables);
			gids.forEach(gid => {
				let found = unavailables.find(prd => prd.id === gid.id);
				if(found) {				
					if(gid.type == "product") {
						let select = shadowRoot.querySelector(`option[value="${gid.gid}"]`);
						let selected = shadowRoot.querySelector(`option[value="${gid.gid}"]:checked`);
						let _gid = `gid://shopify/ProductVariant/${gid.id}`;

						if(selected) {
							selected.setAttribute("selected","");
							if(selected.getAttribute('value') === _gid) {
								let btn = select.closest('.slot-product__container').querySelector('.slot-product__button');
								btn.classList.add('sold-out');
								btn.textContent = window.theme.variantStrings.soldOut;
								btn.disabled = true;
							}
						}
					} 
					else if(gid.type == "variant") {
						let button = shadowRoot.querySelector(`[data-gid="${gid.gid}"]`);
						button.classList.add('sold-out');
						button.textContent = window.theme.variantStrings.soldOut;
						button.disabled = true;
					}
				}
			});

			let selects = shadowRoot.querySelectorAll('.select-variants');
			if(selects) {
				selects.forEach(select => {
					select.options[0].setAttribute('selected','');
					let options = select.querySelectorAll('option');
					options.forEach(option => {
						let gidSplit = option.value.split('/'),
							variantID = Number(gidSplit.at(-1)),
							isUnavailable = unavailables.find(item => item.id === variantID);
						if(isUnavailable) {
							option.setAttribute("data-available", false);
						} else {
							option.setAttribute("data-available", true);
						}
					})
				})
			}
		});
	}
	catch {
		console.error("Fetched data is not an array");
	}
}



function onVariantChange(shadowRoot) {
	selects = shadowRoot.querySelectorAll('.select-variants');
	selects.forEach((select) => {
		select.addEventListener('change', () => {
			select.querySelector('option[selected]').removeAttribute('selected');
			let selected = select.querySelector('option:checked');
			selected.setAttribute('selected','');

			let btn = select.closest('.slot-product__container').querySelector('.slot-product__button');
			
			if(selected.dataset.available == true || selected.dataset.available == "true" || selected.getAttribute('data-available') == "true") {
				btn.classList.remove('sold-out');
				btn.textContent = window.theme.variantStrings.addToCart;
				btn.disabled = false;
			} else {
				btn.classList.add('sold-out');
				btn.textContent = window.theme.variantStrings.soldOut;
				btn.disabled = true;
			}
		});
	});	
}



async function init() {	
	const shadowRoot = await checkQuiz();
	if(shadowRoot) {		
		await addVariantsGIDOnLoad(shadowRoot);		
		await addEventTriggers(shadowRoot);
	}	
}



// async function checkBunnings() {
// 	try {
// 		let bunnings = await checkProductResultCards()
// 	} catch (error) {
// 		console.log(error.message);
// 	}
// }

function addEventTriggers(shadowRoot) {
	shadowRoot.addEventListener("click", event => {
		checkBunnings();
	});

	onVariantChange(shadowRoot);
}

document.addEventListener("DOMContentLoaded", () => {
});

window.addEventListener("load", () => {
	window.addEventListener('message', async function(event) {
		if(event.data === 'isResult') {
			init();
			return;
		}
	});

	init();
});
